import {
  Button,
  FormControl,
  HStack,
  Textarea,
  VStack,
} from "@chakra-ui/react";
import React from "react";
import { Trans } from "react-i18next";

/**
 * Renders the AI form
 * 
 * @param {Function} register The form registration function
 * @param {Function} copyToClipboard The copy to clipboard function
 * @returns The AI form
 */
const AiForm = ({ register, copyToClipboard }) => {
  return (
    <VStack height={"full"}>
      <FormControl height={"full"}>
        <Textarea id="ai" height={"full"} backgroundColor={"#2D313A"} borderRadius={"10px"} color={"gray.400"} readOnly {...register("ai")} />
      </FormControl>
      <HStack width={"full"} justifyContent={"space-around"} mt={"8px"}>
        <Button
          size={"md"}
          colorScheme="whiteAlpha"
          onClick={copyToClipboard}
          borderRadius={"10px"}
          width={"full"}
        >
          <Trans>beneficiaryFile.form.copy</Trans>
        </Button>
      </HStack>
    </VStack>
  );
};

export default AiForm;
